// constants.js


export const server = 'https://begriff.co/api'



//export const server = process.env.VUE_APP_SERVER_URL;


